import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

export const revealProgressBarToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'reveal_progress_bar',
  description: 'Make the coaching progress bar visible. Call this exactly once, when you begin presenting the session structure to the user (e.g. "Ich schlage vor, wir gehen durch Rolle, Skills, Gaps..."). Do not call this at any other time.',
  parameters: {
    type: 'object',
    properties: {},
    required: [],
    additionalProperties: false
  }
};

export const revealProgressBarToolMetroImplementation: ToolImplementation = async (): Promise<ToolResult> => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('metro-reveal-progress'));
  }
  return { success: true, data: 'Progress bar revealed.' };
};
